import React from 'react'

const PartEight = () => {
  return (
    <><br/>
        <div className="row">
            <div className="col-xl-12 col-md-12">
                <br/>
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<strong>หมวดที่ 5 หน้าที่และความรับผิดของผู้รับจ้าง</strong>
                </p> 
            </div>
        </div>
        <div className="row">
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.1 ผู้รับจ้างจะต้องปฏิบัติ และดำเนินการก่อสร้างให้ถูกต้องตามหนังสือสัญญาจ้างก่อสร้างบ้านพักอาศัยนี้ เพื่อให้งานสำเร็จบรรลุตามความมุ่งหมายของผู้ว่าจ้าง
                </p> 
            </div>
        </div>
        <div className="row">
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.2 ผู้รับจ้างสามารถโอนงาน หรือนำงานส่วนใดส่วนหนึ่ง หรือทั้งหมดตามสัญญานี้ไปให้ผู้อื่น หรือนิติบุคคลบุคคลอื่นรับจ้างช่วงได้ แต่ผู้รับจ้างยังต้องรับผิดชอบงานที่รับจ้างช่วงนั้นทุกประการ
                </p> 
            </div>
        </div>
        <div className="row">
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.3 ผู้รับจ้างต้องแจ้งให้ผู้ว่าจ้างทราบเป็นลายลักษณ์อักษรว่าต้องยื่นเรื่องขออนุญาตต่อเจ้าพนักงานภายในเวลาที่กำหนด นับแต่วันที่ผู้ว่าจ้างและผู้รับจ้างตกลงแก้ไข หรือเพิ่มเติม หรือลดงานตามข้อ 4.1
                </p> 
            </div>
        </div>
        <div className="row">
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.4 ผู้รับจ้างต้องรับผิดในอุยัติภัยต่ายๆ ที่เกิดขึ้นโดยตรงหรือเป็นผลมาจากการก่อสร้างตามสัญญานี้
                </p> 
            </div>
        </div>
        <div className="row">
            <div className="col-xl-12 col-md-12 d-flex align-items-center">
                <p>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.5 ผู้รับจ้างยินยอมให้ผู้ว่าจ้างหรือตัวแทนที่ผู้ว่าจ้างแต่งตั้งเข้าตรวจตราบ้าน ที่ก่อสร้าง และวัสดุที่ใช้ในการก่อสร้างได้ตลอดเวลา หากผู้ว่าจ้างหรือตัวแทนที่ผู้ว่าจ้างแต่งตั้งเห็นว่างานที่ปฏิบัติอยู่ขณะนั้น หรือวัสดุที่นำมาใช้ไม่ได้ขนาดหรือมาตรฐานตามที่กำหนด ตามรายละเอียดที่ระบุไว้ในสัญญาหรือแนบท้ายสัญญานี้ ผู้ว่าจ้างหรือตัวแทน ที่ผู้ว่าจ้างแต่งตั้งมีสิทธิ์ระงับการปฏิบัติงานหรือยกเลิกวัสดุนั้นๆ ได้โดยแจ้งให้ผู้รับจ้างทราบเป็นลายลักษณ์อักษร
                </p> 
            </div>
        </div>
    </>  
  )
}

export default PartEight